import { lazy } from 'react'

// ** Document title
const TemplateTitle = '%s - Belobaba Crypto Fund'

// ** Default Route
const DefaultRoute = '/spinner'

// ** Merge Routes
const Routes = [
  {
    path: '/home',
    component: lazy(() => import('../../views/Home'))
  },
  {
    path: '/second-page',
    component: lazy(() => import('../../views/SecondPage'))
  },
  {
    path: '/settings',
    component: lazy(() => import('../../views/Settings'))
  },
  {
    path: '/contracts',
    component: lazy(() => import('../../views/Contracts'))
  },
  {
    path: '/liquidations',
    component: lazy(() => import('../../views/Liquidations'))
  },
  {
    path: '/ambassadors',
    component: lazy(() => import('../../views/Ambassador'))
  },
  {
    path: '/contract',
    component: lazy(() => import('../../views/Reports'))
  },
  {
    path: '/login',
    component: lazy(() => import('../../views/Login')),
    layout: 'BlankLayout'
  },
  {
    path: '/forgotpw',
    component: lazy(() => import('../../views/ForgotPassword')),
    layout: 'BlankLayout'
  },
  {
    path: '/resetpw',
    component: lazy(() => import('../../views/ResetPassword')),
    layout: 'BlankLayout'
  },
  {
    path: '/signup',
    component: lazy(() => import('../../views/Signup')),
    layout: 'BlankLayout'
  },
  {
    path: '/kyc',
    component: lazy(() => import('../../views/Kyc')),
    layout: 'BlankLayout'
  },
  {
    path: '/kycpending',
    component: lazy(() => import('../../views/KycPending')),
    layout: 'BlankLayout'
  },
  {
    path: '/kycrepeat',
    component: lazy(() => import('../../views/KycRepeat')),
    layout: 'BlankLayout'
  },
  {
    path: '/error',
    component: lazy(() => import('../../views/Error')),
    layout: 'BlankLayout'
  },
  {
    path: '/spinner',
    component: lazy(() => import('../../views/Spinner')),
    layout: 'BlankLayout'
  },
  {
    path: '/bbcn',
    component: lazy(() => import('../../views/BBCN'))
  }

]

export { DefaultRoute, TemplateTitle, Routes }
